import 'babel-polyfill'
import Vue from 'vue';
import App from './App.vue';
import https from '../https.js';
import '../directives.js'
import "../stopNumberMousewheel";
import router from './router';
import permission from './assets/util/permission.js';
import taxui from 'tax-ui'
/* import '@/permission.js' */
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import {messages} from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import echarts from 'echarts'
import tolertJSON from '../src/db.json'
import minhead from './components/common/minhead.vue'
import kgdiag from './components/common/kgdiag.vue'
import datajson from '../src/data.json'
import Billingcomponent from './components/common/Billingcomponent.vue'
import less from 'less'
import obj from './comMapping.js'
for (let key in obj) {
 Vue.prototype[key] = obj[key]
}
Vue.prototype.$echarts = echarts
Vue.use(taxui)
import taxunionexpress from "taxunion-express"
Vue.use(taxunionexpress);
Vue.component('Billingcomponent', Billingcomponent);
Vue.prototype.baseURL = 'https://a.jz5u.com/apis/uploadFile' //正式图片上传地址
import addCommoditymasterdata from './components/common/addCommoditymasterdata.vue'
Vue.component('addCommoditymasterdata', addCommoditymasterdata);
import downloadcommon from './components/common/downloadcommon.vue'
Vue.component('downloadcommon', downloadcommon);
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.prototype.$https = https;
Vue.prototype.$datajson = datajson;
Vue.prototype.$tolertJSON = tolertJSON;
Vue.component('minhead', minhead);
Vue.component('kgdiag', kgdiag);

Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});
Vue.use(less)

Vue.prototype.guid = function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
},
  Vue.prototype.GetLength = function (str) {
        if(str){
            var l = str.length;
            var blen = 0;
            for ( var i = 0; i < l; i++) {
                if ((str.charCodeAt(i) & 0xff00) != 0) {
                    blen++;
                    blen++;
                }
                blen++;
            }
            return blen;
        }
    },
    Vue.prototype.generateTimeReqestNumber = function (stirng) {
        var date = new Date();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentDate = date.getFullYear() + "-" + month + "-" + strDate +
            " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        return currentDate;
    },
    Vue.prototype.fapiaotonum = function (stirng) { //类型代号转文字
        if (stirng == '电子专票') {
            return '028'
        } else if (stirng == '纸质专票') {
            return '004'
        } else if (stirng == '纸质普票') {
            return '007'
        } else if (stirng == '电子普票') {
            return '026'
        }
    },
    Vue.prototype.numtofapiao = function (stirng) { //类型代号转文字
        if (stirng == '028') {
            return '电子专票'
        } else if (stirng == '004') {
            return '纸质专票'
        } else if (stirng == '007') {
            return '纸质普票'
        } else if (stirng == '026') {
            return '电子普票'
        }
    },
	Vue.prototype.numtofapiaotitle = function (stirng,title) { //类型代号转文字
		if(title!="手工录入"){
			return ''
		}
	    if (stirng == '028') {
	        return '单据录入 - 电子专票填开'
	    } else if (stirng == '004') {
	        return '单据录入 - 纸质专票填开'
	    } else if (stirng == '007') {
	        return '单据录入 - 纸质普票填开'
	    } else if (stirng == '026') {
	        return '单据录入 - 电子普票填开'
	    }
	},
    Vue.prototype.notemptyandnull = function (stirng) {
        if (stirng != "" & stirng != null) {
            return true
        } else {
            return false
        }
    },
    Vue.prototype.emptyandnull = function (stirng) {
        if (stirng == "" || stirng == null) {
            return true
        } else {
            return false
        }
    },

    Vue.prototype.mostostring = function (mos) { //类型代号转文字
        if (mos == '1') {
            return '导入'
        } else if (mos == '2') {
            return '导出'
        }
    },
    Vue.prototype.shitlmctostring = function (string) { //类型代号转文字
        if (string == 'Dj') {
            return '单据及单据明细'
        } else if (string == 'Doc') {
            return '发票及发票明细'
        }
    },
    Vue.prototype.typetostring = function (num) { //类型代号转文字
        if (num == '0') {
            return '超级管理员'
        } else if (num == '1') {
            return '集团管理员'
        } else if (num == '2') {
            return '实体管理员'
        } else if (num == '3') {
            return '一般用户'
        }
    },
    Vue.prototype.statetostring = function (num) { //类型代号转文字
        if (num == '0') {
            return '停用'
        } else if (num == '1') {
            return '正常'
        }
    },
    Vue.prototype.statbacketostring = function (num) { //类型代号转文字
        console.log(num);
        if (num == '0') {
            return '正常'
        } else if (num == '1') {
            return '停用'
        }
    },
    Vue.prototype.zhuangttostring = function (num) { //类型代号转文字
        if (num == '1') {
            return '处理中'
        } else if (num == '2') {
            return '成功'
        } else if (num == '3') {
            return '失败'
        }
    },
    Vue.prototype.shuilvtotemp = function (num) { //类型代号转文字
        if (num == null || num == "") {
            return ""
        }
        let spstr = num.split("");
        if (spstr[spstr.length - 1] == "%") {
            return num
        }
        return parseFloat(num) * 100 + "%"
    },
    Vue.prototype.formatdate = function (value) {
        if (value == 'undefined' || value == '' || value == null) {
            return ''
        } else {
            let date = new Date(parseInt(value))
            let y = date.getFullYear()
            let MM = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            let h = date.getHours()
            h = h < 10 ? ('0' + h) : h
            let m = date.getMinutes()
            m = m < 10 ? ('0' + m) : m
            let s = date.getSeconds()
            s = s < 10 ? ('0' + s) : s
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        }
    },
    Vue.prototype.fapzttostring = function (num) { //类型代号转文字
        if (num == '0') {
            return '待审核'
        } else if (num == '1') {
            return '已审核'
        } else if (num == '2') {
            return '待开票'
        } else if (num == '3') {
            return '开票中'
        } else if (num == '4') {
            return '已开票'
        } else if (num == '7') {
            return '开票失败'
        } else if (num == '8') {
            return '暂不开票'
        } else if (num == '9') {
            return '已退票'
        } else if (num == '34') {
            return '无需开票'
        }
    },
    Vue.prototype.pricetonew = function (n) { //类型代号转文字
	   // if (!/^(0|\-*[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";
	          var fuhao = (n.toString().indexOf("-")==0?"（负数）":"");
	            var unit = "仟佰拾亿仟佰拾万仟佰拾圆角分", str = "";
	                n += "00";
	             //如果是负数就就截取
	             if(fuhao == "（负数）"){
	            n = n.substring(1, n.length);
	             }
	            var p = n.indexOf('.');
	            if (p >= 0)
	                n = n.substring(0, p) + n.substr(p+1, 2);
	                unit = unit.substr(unit.length - n.length);
	            for (var i=0; i < n.length; i++)
	                str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
	            return fuhao+str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|圆)/g, "$1").replace(/(亿)万|(拾)/g, "$1$2").replace(/^圆零?|零分/g, "").replace(/圆$/g, "圆整");

    },
    Vue.prototype.keepTwoDecimal = function (num) { //类型代号转文字
        var result = parseFloat(num);
        if (isNaN(result)) {

            return num;
        }
        result = Math.round(num * 100) / 100;
        var s_x = result.toString();
        var pos_decimal = s_x.indexOf('.');
        if (pos_decimal < 0) {
            pos_decimal = s_x.length;
            s_x += '.';
        }
        while (s_x.length <= pos_decimal + 2) {
            s_x += '0';
        }
		console.log(head)
        return s_x;
    },

    Vue.prototype.formatkpgz = function (value) {
        var valueformat
        switch (value) {
            case "1":
                valueformat = "拆分金额"
                break;
            case "2":
                valueformat = "拆分最大明细行"
                break;
            case "3":
                valueformat = "发票分组"
                break;
            case "4":
                valueformat = "合并明细"
                break;
            case "5":
                valueformat = '替换商品名称'
                break;
            case '6':
                valueformat = "替换客户名称"
                break;
            case '7':
                valueformat = "替换商品单位"
                break;
            case '8':
                valueformat = "替换商品规格"
                break;
            case '9':
                valueformat = "修改单据状态"
                break;
            case '10':
                valueformat = "修改备注"
                break;

        }
        return valueformat
    },
    Vue.prototype.stringtostmp = function (string) { //后台格式转日期
        if (string != "" & string != null) {
            if (string.length < 14) {
                return ""
            }
            var alllist = string.split("");
            var tmp = alllist[0] + alllist[1] + alllist[2] + alllist[3] + "年" + alllist[4] + alllist[5] + "月" + alllist[6] + alllist[7] + "日" + " " + alllist[8] + alllist[9] + "时" + alllist[10] + alllist[11] + "分" + alllist[12] + alllist[13] + "秒"

            return tmp
        } else {
            return ""
        }

    },
    Vue.prototype.timestampToTimesfm = function (string) { //后台格式转日期
        if (string != "" & string != null) {
            if (string.length < 14) {
                return ""
            }
            var alllist = string.split("");
            var tmp = alllist[0] + alllist[1] + alllist[2] + alllist[3] + "年" + alllist[4] + alllist[5] + "月" + alllist[6] + alllist[7] + "日" + " " + alllist[8] + alllist[9] + "时" + alllist[10] + alllist[11] + "分" + alllist[12] + alllist[13] + "秒"

            return tmp
        } else {
            return ""
        }

    },
    //自动化格式化时间戳日期 兼容数字类型字符类型，秒级，毫秒级，以及常见的时间格式
    Vue.prototype.formatTimestamp = function (timestamp, format) {
        if (!timestamp) {
            return timestamp;
        }
        // 判断参数timestamp是否为时间戳  
        if (typeof timestamp === 'number' || typeof timestamp === 'string') {
            // 根据时间戳长度兼容秒数和毫秒数  
            let date = new Date(timestamp);
            if (typeof timestamp === 'number') {
                let str = timestamp + "";
                if (str.length === 10) {
                    date = new Date(parseInt(timestamp) * 1000);
                }
            } else if (typeof timestamp === 'string' && timestamp.length === 10) {
                date = new Date(parseInt(timestamp) * 1000);
            } else if (typeof timestamp === 'string' && timestamp.length === 13) {
                date = new Date(parseInt(timestamp) * 1);
            } else if (typeof timestamp === 'string' && timestamp.length === 14) {// 兼容 yyyyMMddHHmmss 格式时间
                const regex = /^[0-9]{14}$/;
                if (regex.test(timestamp)) {
                    date = new Date(timestamp.slice(0, 4) + "-" + timestamp.slice(4, 6) + "-" + timestamp.slice(6, 8) + "T" + timestamp.slice(8, 10) + ":" + timestamp.slice(10, 12) + ":" + timestamp.slice(12, 14));
                }
            }
            // 转换日期格式  
            let year = date.getFullYear();
            let month = ('0' + (date.getMonth() + 1)).slice(-2);
            let day = ('0' + date.getDate()).slice(-2);
            let hours = ('0' + date.getHours()).slice(-2);
            let minutes = ('0' + date.getMinutes()).slice(-2);
            let seconds = ('0' + date.getSeconds()).slice(-2);
            let result = year + '年' + month + '月' + day + '日' + hours + '时' + minutes + '分' + seconds + '秒';
            return format ? format.replace(/yyyy/g, year).replace(/MM/g, month).replace(/dd/g, day).replace(/HH/g, hours).replace(/mm/g, minutes).replace(/ss/g, seconds) : result;
        } else {
            // 参数timestamp不是时间戳，尝试识别为常见时间格式并转换  
            let date = new Date(timestamp);
            if (!isNaN(date.getTime())) {
                // 转换日期格式  
                let year = date.getFullYear();
                let month = ('0' + (date.getMonth() + 1)).slice(-2);
                let day = ('0' + date.getDate()).slice(-2);
                let hours = ('0' + date.getHours()).slice(-2);
                let minutes = ('0' + date.getMinutes()).slice(-2);
                let seconds = ('0' + date.getSeconds()).slice(-2);
                let result = year + '年' + month + '月' + day + '日' + hours + '时' + minutes + '分' + seconds + '秒';
                return format ? format.replace(/yyyy/g, year).replace(/MM/g, month).replace(/dd/g, day).replace(/HH/g, hours).replace(/mm/g, minutes).replace(/ss/g, seconds) : result;
            } else {
                throw new Error('Invalid timestamp or date format ---- timestamp=>' + timestamp + ' format=>' + format);
            }
        }

    },
    Vue.prototype.yyyyMMdd = function (value) {
        if (value === undefined || value === null || value === '') {
            return "";
        }

        if (value.length < 8) {
            return ""
        }

        return value.substring(0, 4) + "年" + value.substring(4, 6) + "月" + value.substring(6, 8) + "日";
    },
    Vue.prototype.yyyyMM = function (value) {
        if (value === undefined || value === null || value === '') {
            return "";
        }

        if (value.length < 8) {
            return ""
        }

        return value.substring(0, 4) + "年" + value.substring(4, 6) + "月";
    }
    ,
    Vue.prototype.rowtofapiao = function (row) { //类型代号转文字
        let stirng = row.faplxdm;
        if (stirng == '028') {
            return '电子专票'
        } else if (stirng == '004') {
            return '纸质专票'
        } else if (stirng == '007') {
            return '纸质普票'
        } else if (stirng == '026') {
            return '电子普票'
        }
    },
    Vue.prototype.rowfapzttostring = function (row) { //类型代号转文字
        let num = row.fapzt;
        if (num == '0') {
            return '待审核'
        } else if (num == '1') {
            return '已审核'
        } else if (num == '2') {
            return '待开票'
        } else if (num == '3') {
            return '开票中'
        } else if (num == '4') {
            return '已开票'
        }  else if (num == '5') {
            return '已作废'
        } else if (num == '6') {
            return '已红冲'
        } else if (num == '7') {
            return '开票失败'
        } else if (num == '8') {
            return '暂不开票'
        } else if (num == '9') {
            return '已退票'
        } else if (num == '34') {
            return '无需开票'
        }
    },
    Vue.prototype.rowfaplytostring = function (row) { //类型代号转文字
        let num = row.faply;
        if (num == '1') {
            return '文件导入'
        } else if (num == '2') {
            return '手工录入'
        } else if (num == '3') {
            return '客户接口'
        } else if (num == '4') {
            return '税控同步'
        }else if (num == '5') {
            return '支付开票'
        }else if (num == '6') {
            return '扫码开票'
        }else if (num == '7') {
            return '红冲重开'
        }else if (num == '8') {
            return '作废重开'
        }
    },
    Vue.prototype.timestampToStr = function(timestamp,template){
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear();
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
        var D = (date.getDate()+1 < 10 ? '0'+(date.getDate()+1) : date.getDate()+1);
        var h = (date.getHours()+1 < 10 ? '0'+(date.getHours()+1) : date.getHours()+1);
        var m = (date.getMinutes()+1 < 10 ? '0'+(date.getMinutes()+1) : date.getMinutes()+1);
        var s = (date.getSeconds()+1 < 10 ? '0'+(date.getSeconds()+1) : date.getSeconds()+1);
        return template.replace('yyyy', Y).replace('MM',M).replace('dd',D).replace('hh',h).replace('mm',m).replace('ss',s);
    },
    Vue.prototype.fapztlist = [
        {
            label: "草稿",
            value: "-1",
            style:"color:#BEBEBE"
        },
        {
            label: "待审核",
            value: "0",
            style:""
        },
        {
            label: "已审核",
            value: "1",
            style:"color:#00DC16"
        },
        {
            label: "待开票",
            value: "2",
            style:"color:#EE0101"
        },
        {
            label: "开票中",
            value: "3",
            style:"color:#2F66FC"
        },
        {
            label: "已开票",
            value: "4",
            style:"color:#FF8000"
        },
        {
            label: "已作废",
            value: "5",
            style:"color:#FF8000"
        },
        {
            label: "已红冲",
            value: "6",
            style:"color:#FF8000"
        },
        {
            label: "开票失败",
            value: "7",
            style:"color:#BEBEBE;display: flex;align-items: center;"
        },
        {
            label: "暂不开票",
            value: "8",
            style:"color:#00DC16"
        },
        {
            label: "已退票",
            value: "9",
            style:"color:#00DC16"
        },
        {
            label: "已合并",
            value: "10",
            style:"color:#00DC16"
        },
        {
            label: "作废关闭中",
            value: "21",
            style:"color:#00DC16"
        },
        {
            label: "作废重开中",
            value: "22",
            style:"color:#00DC16"
        },
        {
            label: "作废锁定",
            value: "23",
            style:"color:#00DC16"
        },
        {
            label: "未开发票冲销",
            value: "31",
            style:"color:#00DC16"
        },
        {
            label: "已开发票冲销",
            value: "32",
            style:"color:#00DC16"
        },
        {
            label: "作废冲销",
            value: "33",
            style:"color:#00DC16"
        },
        {
            label: "无需开票",
            value: "34",
            style:"color:#00DC16"
        },
        {
            label: "待作废",
            value: "35",
            style:"color:#00DC16"
        },
    ],
    Vue.prototype.fplxlist = [{
        label: '纸质专票',
        value: '004'
    }, {
        label: '纸质普票',
        value: '007'
    }, {
        label: '电子普票',
        value: '026'
    }, {
        label: '电子专票',
        value: '028'
    }],
    Vue.prototype.setSelectKey = function (obj) {
        let pArr = Object.keys(obj).map(key => ({
            value: key,
            label: obj[key]
        }));
        return pArr;
    }
// 仟分位符
Vue.prototype.toThousands = function (num) {
    if(num==null||num=="undefined"||num==undefined){
        return "0";
    }else if(num == ""){
        return parseFloat(0).toFixed(2);
    }else{
        if(num < 0 ){
            var numstr = String(num);
            var nums = numstr.substr(1);
            var s = parseFloat(nums).toFixed(2);
            var L = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            for(var i=0; i<L.length; i++){
                if((i+1)%3 == 0 && (i + 1) != L.length){
                    t += L[i] + ",";
                }else{
                    t += L[i] + "";
                }
            }
            return "-" + t.split("").reverse().join("")+"."+r;
        }else if(num > 0){
            var s = parseFloat(num).toFixed(2);
            var L = s.split(".")[0].split("").reverse();
            var r = s.split(".")[1];
            var t = "";
            for(var i=0; i<L.length; i++){
                if((i+1)%3 == 0 && (i + 1) != L.length){
                    t += L[i] + ",";
                }else{
                    t += L[i] + "";
                }
            }
            return t.split("").reverse().join("")+"."+r;
        }else{
            return parseFloat(0).toFixed(2);
        }
    }
};
// 金额格式化
Vue.prototype.Amountformat = function (number) {
  var decimal = 2;
      var s = String(number);
      var decimalIndex = s.indexOf('.'); 
      if (decimalIndex < 0) {
          var fraction = '';
          for (var i = 0; i < decimal; i++) {
              fraction += '0';
          }
          return s + '.' + fraction;
      }
      var numDigits = s.length - 1 - decimalIndex;
      if (numDigits <= decimal) {
          var fraction = '';
          for (var i = 0; i < decimal - numDigits; i++) {
              fraction += '0';
          }
          return s + fraction;
      }
      var digits = s.split('');
      var pos = decimalIndex + decimal;
      var roundDigit = digits[pos + 1];
      if (roundDigit > 4) {
          //跳过小数点
          if (pos == decimalIndex) {
              --pos;
          }
          digits[pos] = Number(digits[pos] || 0) + 1;
          //循环进位
          while (digits[pos] == 10) {
              digits[pos] = 0;
              --pos;
              if (pos == decimalIndex) {
                  --pos;
              }
              digits[pos] = Number(digits[pos] || 0) + 1;
          }
      }
      //避免包含末尾的.符号
      if (decimal == 0) {
          decimal--;
      }
      return digits.slice(0, decimalIndex + decimal + 1).join('');
};
Vue.prototype.validateHejjeAndHejse = function (rule, value, callback) {

    var reg = /^(-?\d+)(\.\d{1,2})?$/;
    if (value!==''&&value!==undefined && !reg.test(value)) {
        callback(new Error('小数位至多2位。'));
    } else {
        callback();
        //this.$refs.ruleForm.validateField('checkPass');
    }
};
Vue.prototype.validateCustomersbh = function (rule, value, callback) {

    var reg = /^[0-9A-Z]*$/g;
    if (value!==''&&value!==undefined &&( value.length !== 15 && value.length !== 18 && value.length !== 20 ||!reg.test(value))) {
        callback(new Error('输入的长度只能是15或18或20位'));
    } else {
        callback();
        //this.$refs.ruleForm.validateField('checkPass');
    }
};

Vue.prototype.validateFaphm = function (rule, value, callback) {

    var reg = /^(-?\d+)?$/;
    if (value!==''&&value!==undefined && (!reg.test(value) || value.length > 8)) {
        callback(new Error('发票号码只能是数字,最长8位。'));
    } else {
        callback();
        //this.$refs.ruleForm.validateField('checkPass');
    }
};
Vue.prototype.validateFapdm = function (rule, value, callback) {

    var reg = /^(-?\d+)?$/;
    if (value!==''&&value!==undefined && (!reg.test(value) || value.length > 12)) {
        callback(new Error('发票代码只能是数字，最长12位。 '));
    } else {
        callback();
        //this.$refs.ruleForm.validateField('checkPass');
    }
};
Vue.prototype.validatePhone = function (rule, value, callback) {

    var reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
    if (value!==''&&value!==undefined && (!reg.test(value))) {
        callback(new Error('手机号码输入错误'));
    } else {
        callback();
        //this.$refs.ruleForm.validateField('checkPass');
    }
};
Vue.prototype.validatePhone = function (rule, value, callback) {

    var reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
    if (value!==''&&value!==undefined && (!reg.test(value))) {
        callback(new Error('手机号码输入错误'));
    } else {
        callback();
        //this.$refs.ruleForm.validateField('checkPass');
    }
};
Vue.prototype.diagheight = function () {
	if(window.innerHeight>850){
		return 570
	}else{
	return window.innerHeight-300
	 }
};
Vue.prototype.diagheightzhengshutiankai = function () {
	if(window.innerHeight>850){
		return 570
	}else{
	return window.innerHeight-340
	 }
};
Vue.prototype.diagheightfushutiankai = function () {
	if(window.innerHeight>850){
		return 570
	}else{
	return window.innerHeight-350
	 }
};
Vue.prototype.formatKaipDate=function (date) {
    if (date != "" & date != null) {
        if (date.length < 14) {
            return ""
        }
        var alllist = date.split("");
        var result= alllist[0] + alllist[1] + alllist[2] + alllist[3] + "年" + alllist[4] + alllist[5] + "月" + alllist[6] + alllist[7] + "日";
        console.log(result);
        return result;
    } else {
        return ""
    }
};
Vue.prototype.printFn=function (value) {
    return parseFloat(value).toFixed(2);
};
Vue.prototype.createPasswordHash=function (password){
    const crypto = require('crypto');
    let salt=crypto.randomBytes(24)
    crypto.pbkdf2(password, salt, 1000, 24,
        '', (err, derivedKey) => {
            return "1000:"+salt.toString('hex')+":"+derivedKey.toString('hex')
        });
    return "";
}
Vue.prototype.encryptionPasswordAes=function (word, keyStr, ivStr){
    let cryptoJS = require("crypto-js");
    let key = cryptoJS.enc.Utf8.parse("bb8faae4000a41ed");
    let iv = cryptoJS.enc.Utf8.parse("d235358e740a4721");

    if (keyStr) {
        key = cryptoJS.enc.Utf8.parse(keyStr);
        iv = cryptoJS.enc.Utf8.parse(ivStr);
    }

    let srcs = cryptoJS.enc.Utf8.parse(word);
    let encrypted = cryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7
    });

    return cryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    return "";
}
Vue.prototype.decryptionPasswordAes=function (word, keyStr, ivStr){
    let cryptoJS = require("crypto-js");
    let key = cryptoJS.enc.Utf8.parse("bb8faae4000a41ed");
    let iv = cryptoJS.enc.Utf8.parse("d235358e740a4721");
    if (keyStr) {
        key = cryptoJS.enc.Utf8.parse(keyStr);
        iv = cryptoJS.enc.Utf8.parse(ivStr);
    }

    let base64 = cryptoJS.enc.Base64.parse(word);
    let src = cryptoJS.enc.Base64.stringify(base64);

    let decrypt = cryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7
    });

    let decryptedStr = decrypt.toString(cryptoJS.enc.Utf8);

    return decryptedStr.toString();
}
new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
